export default "__VITE_PUBLIC_ASSET__d39921de__"